import { cilMoon, cilSun } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import {
  CAlert,
  CBadge,
  CContainer,
  CImage,
  CTooltip,
} from '@coreui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import logo from 'src/assets/brand/logo.png';
import logo_light from 'src/assets/brand/logo_light.png';
import { getHeaders, logout, styler } from 'src/common';
import { env, REACT_APP_SERVER_API } from 'src/config';
import { useTheme } from 'src/providers/Theme';
import { useUser } from 'src/providers/User';
import s from './header.module.css';
import LanguageChanger from './LanguageChanger';
import blankAvatar from 'src/assets/images/blank.svg';
import { errorHandler } from 'src/handlers/ErrorHandler';
import { simpleToast, useToast } from 'src/providers/Toaster';
import AISearchControls from './AISearchControls';
import PaymentBell from './PaymentBell';
import { clearAISearch, useAISearch } from './aiSearchState';

function Header() {
  const [searchTerm, setSearchTerm] = useState('');
  const [userDrowpdown, setUserDrowpdown] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const { user } = useUser();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { theme, setTheme } = useTheme();
  const [dark, setDark] = useState(theme === 'theme-dark');
  const { setToast } = useToast();
  const [messageCount, setMessageCount] = useState(0);
  const aiSearch = useAISearch();
  useEffect(() => {
    let notification_id = localStorage.getItem('notification_id') ?? 0;
    axios
      .post(
        env(REACT_APP_SERVER_API) + 'notification/active_notification',
        { notification_id, lang: i18n.resolvedLanguage },
        { headers: getHeaders() },
      )
      .then((response) => {
        setNotifications(response.data.result);
        setNotifications(
          i18n.resolvedLanguage === 'en'
            ? response.data.result
            : response.data.result.map((i) => ({
                ...i,
                title: i?.translate?.[0]?.title ?? i.title,
                description: i?.translate?.[0]?.description ?? i.description,
              })),
        );
        for (const notification of response.data.result) {
          console.log(notification);
          if (notification.auto_hide > 0)
            setTimeout(() => {
              setNotifications((n) => {
                let deleted = n.splice(
                  n.findIndex((i) => i.id === notification.id),
                  1,
                );
                console.log({ deleted });
                return [...n];
              });
            }, notification.auto_hide * 1000);
        }
      });
  }, [i18n.resolvedLanguage]);

  // Count unread incoming messages, not all tickets with status "answered".
  // Refresh immediately after mark_read succeeds, when the tab is focused,
  // and periodically so messages from another tab are also reflected.
  useEffect(() => {
    if (!user?.username) {
      setMessageCount(0);
      return undefined;
    }

    let alive = true;
    let latestRequest = 0;
    const checkUnread = () => {
      if (document.visibilityState === 'hidden') return;
      const request = ++latestRequest;
      axios.get(env(REACT_APP_SERVER_API) + 'ticket/unread_count', { headers: getHeaders() })
        .then(({ data }) => {
          if (!alive || request !== latestRequest) return;
          if (Number.isSafeInteger(data?.unread_count) && data.unread_count >= 0) {
            setMessageCount(data.unread_count);
          }
        })
        // Keep the prior value if the service is temporarily unavailable.
        .catch(() => {});
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') checkUnread();
    };
    checkUnread();
    const interval = window.setInterval(checkUnread, 25000);
    window.addEventListener('oneclick:ticket-read', checkUnread);
    window.addEventListener('focus', checkUnread);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      alive = false;
      window.clearInterval(interval);
      window.removeEventListener('oneclick:ticket-read', checkUnread);
      window.removeEventListener('focus', checkUnread);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [user?.username]);

  // useEffect(() => {
  //   if (loading)
  //     return;
  //   if (searchTerm.length < 4)
  //     return;
  //   if (waiting)
  //     return;
  //   setWaiting(true)
  //   setTimeout(() => {
  //     setWaiting(false);
  //     setLoading(true);
  //     axios.post(env(REACT_APP_SERVER_API) + 'model/search', { term: searchTerm, page: 1, perPage: 10, lang: i18n.resolvedLanguage }, { headers: getHeaders() })
  //       .then(response => {

  //       }).finally(() => {
  //         setLoading(false);
  //       })

  //   }, 500)
  // }, [searchTerm])

  const handleTheme = (value) => {
    setTheme(value ? 'theme-dark' : 'theme-default');
    setDark(value);
  };

  const handleSearch = (event) => {
    event?.preventDefault();
    const query = searchTerm.trim();
    if (!(aiSearch.active && aiSearch.kind === 'image')) clearAISearch();
    navigate('/models' + (query ? '?searchTerm=' + encodeURIComponent(query) : ''));
  };

  const removeSearchImage = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    clearAISearch();
    setSearchTerm('');
    navigate('/models');
  };

  return (
    // <div>
    <div className={styler(s, 'old-container-fluid sky-header-underline ' + theme)} data-target='block-main-menu'>
      <CContainer lg>
        <nav className={styler(s, 'header')}>
          <div className={styler(s, 'header-top bottom-panel-authorized')}>
            <ul className={styler(s, 'header-menu d-none d-sm-block')}>
              {/* <li>
                <a href="#/home">{t('home')}</a>
              </li> */}
              <li>
                <a href='/#/models'>{t('3dmodels')}</a>
              </li>
              <li>
                <a href='/#/subscriptions'>{t('subscriptions')}</a>
              </li>
              <li>
                <LanguageChanger />
              </li>

              {user?.is_admin && (
                <li>
                  <a href='/#/admin'>{t('adminpanel')}</a>
                </li>
              )}
              <li>
                {/* <CButtonGroup>
                  {Object.keys(lngs).map((lng) => (
                    <CButton color='light' key={lng} style={{ fontWeight: i18n.resolvedLanguage === lng ? 'bold' : 'normal' }} type="submit" onClick={() => i18n.changeLanguage(lng)}>
                      <CIcon size='xxl'
                        icon={lngs[lng].icon}

                      />
                    </CButton>
                  ))}
                </CButtonGroup> */}
              </li>
            </ul>
          </div>
          <div className={styler(s, 'header-content')}>
            <div className={styler(s, 'header-search-group')}>
              <div className={styler(s, 'align-self-center logo d-none d-sm-block')}>
                <div>
                  <a className={styler(s, 'logo')} href='/' rel='nofollow'>
                    <CImage src={dark ? logo_light : logo} alt='' height={40} />
                  </a>
                </div>
              </div>
              <div className={styler(s, 'd-flex flex-grow-1 align-items-center search')}>
                <div
                  className={styler(s, 'input-elements cleaner-ico')}
                  id='cleaner'
                  onClick={() => {}}
                  style={{ display: 'none' }}
                >
                  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z'
                      fill='currentColor'
                    ></path>
                  </svg>
                </div>
                <div
                  className={styler(s, 'input-elements vertical-line')}
                  id='cleaner_vertical_line'
                  style={{ display: 'none' }}
                ></div>
                <div
                  className={styler(s, 'input-elements ng-search-ico')}
                  id='search_glass'
                  onClick={handleSearch}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') handleSearch(event);
                  }}
                  role='button'
                  tabIndex='0'
                  aria-label={t('search') || 'Search'}
                >
                  <svg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15C9.21054 15 10.7873 14.4274 12.0491 13.4633L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4633 12.0491C14.4274 10.7873 15 9.21054 15 7.5C15 3.35786 11.6421 0 7.5 0ZM2 7.5C2 4.46243 4.46243 2 7.5 2C10.5376 2 13 4.46243 13 7.5C13 10.5376 10.5376 13 7.5 13C4.46243 13 2 10.5376 2 7.5Z'
                      fill='currentColor'
                    ></path>
                  </svg>
                  {/* <CIcon icon={loading ? cilCircle : cilSearch} /> */}
                </div>
                {aiSearch.active && aiSearch.kind === 'image' && aiSearch.preview && (
                  <div className={styler(s, 'selected-image-chip')}>
                    <img src={aiSearch.preview} alt='' />
                    <button
                      type='button'
                      onClick={removeSearchImage}
                      aria-label={
                        i18n.resolvedLanguage?.startsWith('ru')
                          ? 'Удалить изображение'
                          : i18n.resolvedLanguage?.startsWith('en')
                            ? 'Remove image'
                            : 'Şəkli sil'
                      }
                      title={
                        i18n.resolvedLanguage?.startsWith('ru')
                          ? 'Удалить изображение'
                          : i18n.resolvedLanguage?.startsWith('en')
                            ? 'Remove image'
                            : 'Şəkli sil'
                      }
                    >
                      ×
                    </button>
                  </div>
                )}
                <form
                  onSubmit={handleSearch}
                >
                  <input
                    type='text'
                    value={searchTerm}
                    id='query_search'
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                    }}
                    className={styler(
                      s,
                      'search-result' +
                        (aiSearch.active && aiSearch.kind === 'image' && aiSearch.preview ? ' search-with-image' : ''),
                    )}
                    name='query'
                    autoComplete='off'
                    placeholder={t('searchplaceholder')}
                  />
                </form>
                <AISearchControls mode='image' />
                <div className={styler(s, 'typeahead')} id='typeahead' style={{ display: 'none' }}></div>
              </div>
              <AISearchControls mode='text' />
            </div>
            <div className={styler(s, 'header-actions d-none d-sm-flex') + ' oc-oneclick-header-actions'}>
              {
                <CTooltip content={dark ? t('lightmode') : t('darkmode')} placement='top'>
                  <button
                    type='button'
                    className={styler(s, 'header-icon-button')}
                    onClick={() => handleTheme(!dark)}
                    aria-label={dark ? t('lightmode') : t('darkmode')}
                    aria-pressed={dark}
                  >
                    <CIcon icon={dark ? cilSun : cilMoon} size='xl' />
                  </button>
                </CTooltip>
              }
              <PaymentBell userId={user?.id} theme={theme} buttonClassName={styler(s, 'header-icon-button')} />
              <div className={styler(s, 'message-button-wrap')}>
                <CTooltip content={t('messages')} placement='top'>
                  <button
                    type='button'
                    className={styler(s, 'header-icon-button')}
                    onClick={() => navigate('tickets')}
                    aria-label={t('messages')}
                  >
                    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true' focusable='false'>
                      <rect x='1.5' y='5' width='23' height='17' rx='4' />
                      <path d='M2.7 7 10.4 12.8Q13 14.8 15.6 12.8L23.3 7' />
                    </svg>
                  </button>
                </CTooltip>
                {messageCount > 0 ? (
                  <CBadge color='danger' className={styler(s, 'message-count')}>
                    {messageCount}
                  </CBadge>
                ) : null}
              </div>
              <div
                className={styler(s, 'user-menu')}
                id='avatar-frame'
                onMouseEnter={() => setUserDrowpdown(true)}
                onMouseLeave={() => setUserDrowpdown(false)}
                onFocus={() => setUserDrowpdown(true)}
                onBlur={(event) => {
                  if (!event.currentTarget.contains(event.relatedTarget)) setUserDrowpdown(false);
                }}
              >
                <button
                  type='button'
                  className={styler(s, 'user-trigger')}
                  onClick={() => setUserDrowpdown((value) => !value)}
                  aria-expanded={userDrowpdown}
                  aria-haspopup='menu'
                  aria-label={user?.username || user?.email || t('profile')}
                >
                  <img
                    src={user?.avatar ? env(REACT_APP_SERVER_API) + 'upload/avatars/' + user.avatar : blankAvatar}
                    className={styler(s, 'avatar empty_avatar round-avatar')}
                    alt=''
                  />
                </button>
                <div
                  className={styler(s, 'ang-avatar-dropdown-block')}
                  style={{ display: userDrowpdown ? 'block' : 'none' }}
                  role='menu'
                >
                  <div className={styler(s, 'ang-avatar-dropdown')}>
                    <div className={styler(s, 'dropdown-user-summary')}>
                      <div className={styler(s, 'dropdown-name')}>
                        <span>{user?.username}</span>
                      </div>
                      <div className={styler(s, 'dropdown-mail')}>{user?.email}</div>
                    </div>
                    <div className={styler(s, 'dropdown-links')}>
                      <a href='#/profile' role='menuitem'>{t('profile')}<span>›</span></a>
                      <a href='#/subscriptions' role='menuitem'>{t('subscriptions')}<span>›</span></a>
                      <a href='#/bills' role='menuitem'>{t('bills')}<span>›</span></a>
                      <a href='#/tickets' role='menuitem'>{t('tickets')}<span>›</span></a>
                    </div>
                    <button
                      type='button'
                      className={styler(s, 'dropdown-logout')}
                      role='menuitem'
                      onClick={() => {
                        logout();
                        setTimeout(() => window.location.reload(), 200);
                      }}
                    >
                      {t('logout')} <span>→</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </CContainer>
      <div className={styler(s, 'notification')}>
        {notifications.map((i) => {
          return (
            <div key={i.id} style={{ background: i.bg_color, borderColor: i.bg_color }}>
              <CAlert
                className='container'
                dismissible
                color='default'
                onClose={() => {
                  localStorage.setItem('notification_id', i.id);
                }}
                style={{
                  background: i.bg_color,
                  borderColor: i.bg_color,
                  color: i.text_color,
                  padding: '5px 45px',
                  margin: '0 auto',
                  textAlign: 'center',
                }}
                key={i.id}
              >
                <strong>{i.title}</strong>
                <br />
                <span dangerouslySetInnerHTML={{ __html: i.description }} />
              </CAlert>
            </div>
          );
        })}
      </div>
      {/* </div> */}
    </div>
  );
}

export default Header;
